/**
 * @description: 艺人上下钟汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ydh-report">
        <div class="ydh-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-date">
                    <div ref="ydhTime">
                        <input type="text" class="form-control laydate-icon" v-model="ydhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ydhEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ydhShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ydh_charger" data-placeholder="请选择主管"></select>
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="ydh_group_txt" ref="ydh_group_txt" readonly @click="ydhEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYdhTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYdhExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ydhList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ydhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ydhExport_allcheck' @click='ydhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="business_date">
                            <label>时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="no_ct_amount">
                            <label>上钟(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="ct_amount">
                            <label>串台(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="free_amount">
                            <label>空闲(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydhExport_checkModel' value="group_members">
                            <label>总人数(人)</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ydhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ydhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="ydh-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="ydh_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYdhGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='ydh_group_allcheck' @click='groupYdhCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in ydh_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='ydh_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ydhGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ydhGroupSub()">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ydhStartTime: "",
                ydhEndTime: "",
                ydh_group_txt: "",
                ydh_group_allcheck: false,
                ydh_c_group_allcheck: false,
                ydh_group_checkboxModel: [],
                c_ydh_group_checkboxModel: [],
                ydh_group_checkboxData: [],
                ydh_group_name: '',
                ydhExport_allcheck: false,
                c_ydhExport_allcheck: false,
                ydhExport_checkModel: [],
                ydhExport_checkData: ['shop_name', 'business_date', 'group_name', 'director_name', 'no_ct_amount', 'ct_amount', 'free_amount', 'group_members'],
                ydhExport_type: 1,
            }
        },
        watch: {
            ydh_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.ydh_group_checkboxModel.length >= this.ydh_group_checkboxData.length) {
                        this.ydh_group_allcheck = true;
                        this.ydh_c_group_allcheck = true;
                    } else {
                        this.ydh_group_allcheck = false;
                        this.ydh_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            ydhExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ydhExport_checkModel.length >= this.ydhExport_checkData.length) {
                        this.ydhExport_allcheck = true;
                        this.c_ydhExport_allcheck = true;
                    } else {
                        this.ydhExport_allcheck = false;
                        this.c_ydhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ydhStartTime = moment().format('YYYY-MM-DD');
            this.ydhEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput(); // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ydhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                            this.ydhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                        }else {
                            this.ydhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                            this.ydhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ydhTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ydhStartTime = start.format('YYYY-MM-DD');
                    _this.ydhEndTime = end.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ydhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.ydh_group_checkboxModel = [];
                                _this.ydh_group_txt = '';
                                if(e.params.data.text == "全部") {
                                    // 主管
                                    $(_this.$refs.ydh_charger).val('').trigger('change');
                                    $(_this.$refs.ydh_charger).prop("disabled", true);
                                    return;
                                }
                                // 主管
                                $(_this.$refs.ydh_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.ydhShop).val(data.response.result[1].id).trigger('change');
                            // 主管
                            $(_this.$refs.ydh_charger).prop("disabled", false);
                            _this.getChargeData(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitYdhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.ydh_charger).html('');
                            $(_this.$refs.ydh_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            })
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },



            // 进入选择组别
            ydhEnterGroup: function() {
                this.c_ydh_group_checkboxModel = this.ydh_group_checkboxModel;
                this.ydh_group_checkboxModel = [];
                this.getYdhGroupData();
                this.ydh_group_checkboxModel = this.c_ydh_group_checkboxModel;
                $('.ydh-list').hide();
                $('.ydh-group').show();
            },
            // 获取组别列表
            getYdhGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ydhShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.ydh_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ydh_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYdhCheckedAll: function() {
                let _this = this;
                _this.ydh_group_allcheck = _this.ydh_c_group_allcheck;
                if(!_this.ydh_group_allcheck) { // 实现全选
                    _this.ydh_group_checkboxModel = [];
                    _this.ydh_group_checkboxData.forEach(function(item) {
                        _this.ydh_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.ydh_group_checkboxModel = [];
                }
            },
            // 返回
            ydhGroupBack: function() {
                $('.ydh-group').hide();
                $('.ydh-list').show();
                this.ydh_group_checkboxModel = this.c_ydh_group_checkboxModel;
            },
            ydhGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.ydh_group_checkboxData.forEach(function(item) {
                    _this.ydh_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.ydh_group_txt = arr.join(',');
                $('.ydh-group').hide();
                $('.ydh-list').show();
            },
            // 表格
            innitYdhTable: function() {
                let _this = this;
                $(_this.$refs.ydhList).bootstrapTable('destroy');
                $(_this.$refs.ydhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYdhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "10%"
                    }, {
                        field: "business_date",
                        title: "时间",
                        width: "10%"
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "8%"
                    }, {
                        field: "director_name",
                        title: "主管",
                        width: "8%"
                    }, {
                        field: "no_ct_amount",
                        title: "上钟(人)",
                        width: "9%"
                    }, {
                        field: "ct_amount",
                        title: "串台(人)",
                        width: "9%"
                    }, {
                        field: "free_amount",
                        title: "空闲(人)",
                        width: "10%"
                    }, {
                        field: "group_members",
                        title: "总人数(人)",
                        width: "9%"
                    }],
                });
            },
            // 数据
            getYdhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ydhStartTime,
                            "end_time": _this.ydhEndTime,
                            "shop_id": $(_this.$refs.ydhShop).val(),
                            "group_id": _this.ydh_group_checkboxModel,
                            "director_uid": $.trim($(_this.$refs.ydh_charger).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPersonnelPunchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYdhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/personnelPunchExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ydhExport_checkModel = data.response.result.export_fields;
                                _this.ydhExport_type = data.response.result.export_type;
                            } else {
                                _this.ydhExport_checkModel = _this.ydhExport_checkData;
                                _this.ydhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ydhExport_alert)
                }, function() {
                    _this.exportYdhList();
                });
            },
            // 导出字段全选
            ydhExportCheckedAll: function() {
                let _this = this;
                _this.ydhExport_allcheck = _this.c_ydhExport_allcheck;
                if(!_this.ydhExport_allcheck) { // 实现全选
                    _this.ydhExport_checkModel = [];
                    _this.ydhExport_checkData.forEach(function(item) {
                        _this.ydhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ydhExport_checkModel = [];
                }
            },
            // 导出
            exportYdhList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.ydhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/personnelPunchExport?" +
                    "start_time=" + _this.ydhStartTime +
                    "&end_time=" + _this.ydhEndTime +
                    "&shop_id=" + $(_this.$refs.ydhShop).val() +
                    "&group_id=" + _this.ydh_group_checkboxModel +
                    "&director_uid=" + $.trim($(_this.$refs.ydh_charger).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ydhExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .ydh-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>